import { API_BASE_URL } from '../client';

export const MONITOR_ENDPOINTS = {
  KEY_NODE: {
    LIST: `${API_BASE_URL}/KeyNode`,
    DETAIL: (id: number) => `${API_BASE_URL}/KeyNode/${id}`,
    CREATE: `${API_BASE_URL}/KeyNode`,
    UPDATE: (id: number) => `${API_BASE_URL}/KeyNode/${id}`,
    DELETE: (id: number) => `${API_BASE_URL}/KeyNode/${id}`,
    TOGGLE: (id: number) => `${API_BASE_URL}/KeyNode/${id}/toggle`,
    MAPPINGS: (id: number) => `${API_BASE_URL}/KeyNode/${id}/mappings`,
    CASCADE_IPD: `${API_BASE_URL}/KeyNode/cascade/ipd`,
    CASCADE_IPC: `${API_BASE_URL}/KeyNode/cascade/ipc`,
  },
  MONITOR_VIEW: {
    OVERVIEW: `${API_BASE_URL}/MonitorView/overview`,
    RISK_RANKING: `${API_BASE_URL}/MonitorView/risk-ranking`,
    MATRIX: `${API_BASE_URL}/MonitorView/matrix`,
    NODE_ANALYSIS: `${API_BASE_URL}/MonitorView/node-analysis`,
    NODE_ANALYSIS_PROJECTS: `${API_BASE_URL}/MonitorView/node-analysis/projects`,
    PROJECT_DETAIL: (code: string) => `${API_BASE_URL}/MonitorView/project-detail/${encodeURIComponent(code)}`,
    NODE_DETAIL: `${API_BASE_URL}/MonitorView/node-detail`,
    ERP_RECORDS: `${API_BASE_URL}/MonitorView/erp-records`,
  },
  MATCH_NOTE: {
    LIST: `${API_BASE_URL}/MatchNote`,
    CREATE: `${API_BASE_URL}/MatchNote`,
    DELETE: (id: number) => `${API_BASE_URL}/MatchNote/${id}`,
  },
} as const;
